import { runInAction, makeAutoObservable } from "mobx";
import api from "../../api";
import Return from "./Return";

/**
 * @deprecated This store is deprecated and will be removed in a future version.
 * Please use RTK Query hooks for fetching returns data.
 * For manufacturer returns, use `useGetV4ManufacturerByRouteManufacturerIdReturnsQuery`.
 * For reseller returns, use `useGetV4ResellerByRouteResellerIdReturnsQuery`.
 */
class ReturnsStore {
  returns: Return[] = [];
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
    console.warn(
      "Deprecation Warning: The legacy 'ReturnsStore' is in use. Please migrate to RTK Query as outlined in CONTRIBUTING.md."
    );
  }

  getReturns = async (applicationId: string) => {
    this.isLoading = true;
    try {
      const info = await api.returns.retrieveReturns(applicationId);
      const returns = info.map(Return.convertFrom);

      runInAction(() => {
        this.returns = returns;
      });
    } catch (e) {
      console.error(e);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }
}

export default ReturnsStore;
